<template>
    <p class="field-title">{{ label }}
        <QuestionBadge :publishGateEnabled="publishGateEnabled" :required="!!(item && item.required)" />
    </p>
    <Dropdown :modelValue="selectedValue" :options="options" optionLabel="name" :placeholder="placeholder"
        @update:modelValue="handleInput" :disabled="disableEdit" showClear>
        <template #value="slotProps">
            <span v-if="slotProps.value && slotProps.value.name">
                {{ slotProps.value.name }}<span v-if="slotProps.value.deprecated"> (Deprecated)</span>
            </span>
            <span v-else>{{ slotProps.placeholder }}</span>
        </template>
        <template #option="slotProps">
            <span>
                {{ slotProps.option.name }}<span v-if="slotProps.option.deprecated"> (Deprecated)</span>
            </span>
        </template>
    </Dropdown>

    <p v-if="v$.selectedValue.$error" class="error-msg">{{ error_message }}</p>
</template>
<script>
import { ref, watch } from 'vue';
import Dropdown from 'primevue/dropdown';
import { useVuelidate } from '@vuelidate/core';
import QuestionBadge from './QuestionBadge.vue';

export default {
    name: 'SingleSelectDropdownComponent',
    components: {
        Dropdown,
        QuestionBadge,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        error_message: {
            type: String,
        },
        validation_rules: {
            type: Object,
            default: () => ({}),
        },
        disableEdit: {
            type: Boolean,
            required: true,
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        publishGateEnabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const selectedValue = ref(props.modelValue);
        const isInOptions = (value) => {
            return props.options.map((option) => option.name).includes(value.name);
        };
        const v$ = useVuelidate(
            {
                selectedValue: {
                    //isInOptions,
                },
            },
            { selectedValue }
        );
        watch(
            () => props.modelValue,
            (newVal) => {
                selectedValue.value = newVal;
                v$.value.$touch();
                if (!v$.value.selectedValue.$error) {
                    emit('isValid', true);
                } else {
                    emit('isValid', false);
                }
            }
        );

        const handleInput = (newValue) => {
            emit('update:modelValue', newValue);

            if (!v$.value.selectedValue.$error) {
                emit('isValid', true);
            } else {
                emit('isValid', false);
            }
        };

        return { selectedValue, v$, handleInput };
    },
};
</script>
